export default function PHP_tan() {
  return (
    <div>
      <h1>PHP_tan</h1>
    </div>
  );
}
